// Build a snippet payload object from a DOM Range within document content
// This is used for drag-and-drop into Source Package and other cite/save actions.

import {computeNormalizedSelection} from './selectionNormalization';

// range: DOM Range
// docData: { segments?: Array<{ id?: string|number, segmentId?: string|number }>, docUrl?, docTitle? }
// currentDocKey: string
// contentElement: HTMLElement containing document segments
export function buildSelectionSnippet(range, docData, currentDocKey, contentElement) {
    if (!range || !docData) return null;
    const selectedText = range.toString();
    // Trim whitespace and check for empty content
    if (!selectedText || !selectedText.trim()) return null;

    const norm = computeNormalizedSelection(range, contentElement);
    if (!norm) return null;
    const {startIndex, startOffset, endIndex, endOffset} = norm;

    const startSegId =
        docData?.segments?.[startIndex]?.id ||
        docData?.segments?.[startIndex]?.segmentId ||
        startIndex;

    return {
        docId: currentDocKey,
        docUrl: docData?.docUrl,
        docTitle: docData?.docTitle,
        content: selectedText,
        segmentId: startSegId,
        index: startIndex,
        offset: startOffset,
        localId: [currentDocKey, startIndex, startOffset, endIndex, endOffset].join(':'),
        start: {segmentIndex: startIndex, segmentOffset: startOffset},
        end: {segmentIndex: endIndex, segmentOffset: endOffset},
        tags: []
    };
}

